import { createFileRoute } from '@tanstack/react-router';

import { TeamHomePage } from '@/pages/team/team-home-page';
import { TeamMobilePage } from '@/pages/team/team-mobile-page';
import { isTeamPanelTab, type TeamPanelTab } from '@/pages/team/team-tabs';
import { useMobile } from '@/shared/lib/use-mobile';

/**
 * `/teams/:slug?tab=overview|projects|members` — the team page (§6 W5-A).
 * Overview is the default (a Personal space opens on Projects); Docs, Time,
 * Chat and Settings are their own routes. A tab the viewer can't see falls
 * back to the default. Other params (e.g. `?task=KEY`) are left to the shell.
 */
export interface TeamIndexSearch {
  tab?: TeamPanelTab;
}

function TeamHomeRoute() {
  const isMobile = useMobile();
  const { tab } = Route.useSearch();
  return isMobile ? <TeamMobilePage requestedTab={tab} /> : <TeamHomePage requestedTab={tab} />;
}

export const Route = createFileRoute('/teams/$teamSlug/')({
  validateSearch: (raw: Record<string, unknown>): TeamIndexSearch =>
    isTeamPanelTab(raw.tab) ? { tab: raw.tab } : {},
  component: TeamHomeRoute,
});
